import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import { fireOperationalAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { State } from '../../types.tsx';

import {
	SHAREPOINT,
	GOOGLE_DRIVE,
	GoogleDriveAri,
	SharePointAri,
	SHAREPOINT_CONNECTOR,
	GOOGLE_DRIVE_CONNECTOR,
} from '../../../../common/constants.tsx';
import { getConnectionStatus } from '../../../../services/fetch-connection-status/index.tsx';

export const fetchConnectionStatus =
	(cloudId: string, analyticsEvent: UIAnalyticsEvent) =>
	async ({ getState, setState }: StoreActionApi<State>) => {
		try {
			const data = await getConnectionStatus(cloudId);
			const sharepointConnectionStatus = data.find(
				(item) =>
					item.integrationId === SharePointAri.toString() && item.type === SHAREPOINT_CONNECTOR,
			);
			const googleDriveConnectionStatus = data.find(
				(item) =>
					item.integrationId === GoogleDriveAri.toString() && item.type === GOOGLE_DRIVE_CONNECTOR,
			);

			setState({
				...getState(),
				connectionStatus: {
					[SHAREPOINT]: sharepointConnectionStatus || null,
					[GOOGLE_DRIVE]: googleDriveConnectionStatus || null,
				},
			});
		} catch (err) {
			fireOperationalAnalytics(analyticsEvent, 'fetchConnectionStatus failed');
			setState({
				...getState(),
				connectionStatus: {
					[SHAREPOINT]: null,
					[GOOGLE_DRIVE]: null,
				},
			});
		}
	};
